import { Link } from 'react-router-dom';
import { Quote, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { AutoTranslate } from '../../hooks/useAutoTranslate';
import { useLanguage } from '../../context/LanguageContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// "Senaste från Prästens hörna" callout — only renders when a published blog exists.
const PriestCornerSection = ({ blog }) => {
  const { t, language, isRTL } = useLanguage();
  if (!blog) return null;

  const imgSrc = blog.image_url
    ? (blog.image_url.startsWith('http') ? blog.image_url : `${API_URL}${blog.image_url}`)
    : null;

  const titleText = blog.title?.[language] || blog.title?.sv || '';
  const excerptText = blog.excerpt?.[language] || blog.excerpt?.sv || '';

  return (
    <section className="py-16 bg-gradient-to-br from-amber-50 to-yellow-50" data-testid="priest-corner-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-8 ${isRTL ? 'rtl' : ''}`}>
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-2">
            <AutoTranslate>{t('latestFromPriest') || 'Senaste från Prästens hörna'}</AutoTranslate>
          </h2>
        </div>
        <Card className="overflow-hidden shadow-xl card-hover hover:shadow-xl transition-shadow">
          <div className="md:flex">
            {imgSrc && (
              <div className="md:w-1/3 aspect-video md:aspect-auto">
                <img src={imgSrc} alt="" className="w-full h-full object-cover" />
              </div>
            )}
            <CardContent className={`p-6 ${imgSrc ? 'md:w-2/3' : 'w-full'}`}>
              <div className={`flex items-start gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
                <Quote className="w-8 h-8 text-yellow-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className={`font-serif font-bold text-xl text-gray-900 mb-2 ${isRTL ? 'text-right' : ''}`}>
                    <AutoTranslate>{titleText}</AutoTranslate>
                  </h3>
                  {excerptText && (
                    <p className={`text-gray-600 mb-4 line-clamp-3 ${isRTL ? 'text-right' : ''}`}>
                      <AutoTranslate>{excerptText}</AutoTranslate>
                    </p>
                  )}
                  <div className={`flex items-center justify-between ${isRTL ? 'flex-row-reverse' : ''}`}>
                    <span className="text-sm text-gray-500">
                      — {blog.author || 'Kyrkoherden'}
                    </span>
                    <Link to="/prastens-horna">
                      <Button variant="outline" className="text-yellow-700 border-yellow-300 hover:bg-yellow-50">
                        <AutoTranslate>{t('readMore') || 'Läs mer'}</AutoTranslate>
                        <ArrowRight className={`w-4 h-4 ${isRTL ? 'mr-2 rotate-180' : 'ml-2'}`} />
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </CardContent>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default PriestCornerSection;
